import { getItem } from './localStorageControl';
import moment from 'moment-timezone';

export const constructS3FileUrl = (fileName) => {
    if (!fileName) return '';
    if (typeof fileName !== 'string') {
        if (typeof fileName === 'object') {
            const extracted =
                fileName.fileName ||
                fileName.file_name ||
                fileName.url ||
                fileName.URL ||
                fileName.key ||
                fileName.path ||
                fileName.s3Key ||
                fileName.s3_key ||
                fileName.uri ||
                fileName.URI ||
                fileName.name ||
                fileName.src ||
                fileName.href ||
                fileName.sourceUrl ||
                fileName.source_url ||
                fileName.publicUrl ||
                fileName.public_url ||
                fileName.fileUrl ||
                fileName.file_url ||
                fileName.location;
            if (extracted) return constructS3FileUrl(extracted);
        }
        return '';
    }
    let trimmed = fileName.trim();
    if (!trimmed) return '';
    if (
        trimmed.startsWith('http://') ||
        trimmed.startsWith('https://') ||
        trimmed.startsWith('data:') ||
        trimmed.startsWith('blob:')
    ) {
        return trimmed;
    }
    if (trimmed.startsWith('s3://')) {
        trimmed = trimmed.replace(/^s3:\/\/[^/]+\//, '');
    }
    const domain = (process.env.REACT_APP_PUBLIC_ASSETS_DOMAIN || '').replace(/\/+$/, '');
    const cleanFileName = trimmed.replace(/^\/+/, '');
    return domain ? `${domain}/${cleanFileName}` : `/${cleanFileName}`;
};

export const getEventBannerUrl = (event) => {
    if (!event) return '';
    if (typeof event === 'string') return constructS3FileUrl(event);

    const candidates = [
        event.bannerImageUrl,
        event.banner_image_url,
        event.bannerImageKey,
        event.banner_image_key,
        event.bannerUrl,
        event.banner_url,
        event.bannerKey,
        event.banner_key,
        event.bannerImage,
        event.banner_image,
        event.bannerImg,
        event.banner_img,
        event.banner,
        event.coverImage,
        event.cover_image,
        event.coverImageUrl,
        event.cover_image_url,
        event.coverImageKey,
        event.cover_image_key,
        event.coverUrl,
        event.cover_url,
        event.imageUrl,
        event.image_url,
        event.imageKey,
        event.image_key,
        event.eventImage,
        event.event_image,
        event.eventImageUrl,
        event.event_image_url,
        event.image,
        event.asset,
        event.assets,
        event.media,
        event.mediaUrl,
        event.media_url,
        event.file,
        event.fileName,
        event.file_name,
        event.fileUrl,
        event.file_url,
        event.logo,
        event.logoUrl,
        event.logo_url,
    ];

    for (let candidate of candidates) {
        if (!candidate) continue;

        if (Array.isArray(candidate)) {
            if (candidate.length === 0) continue;
            candidate = candidate[0];
        }

        if (typeof candidate === 'string' && candidate.trim()) {
            const resolved = constructS3FileUrl(candidate);
            if (resolved) return resolved;
        }

        if (typeof candidate === 'object') {
            const possibleKeys = [
                candidate.fileName,
                candidate.file_name,
                candidate.url,
                candidate.URL,
                candidate.key,
                candidate.path,
                candidate.s3Key,
                candidate.s3_key,
                candidate.uri,
                candidate.URI,
                candidate.name,
                candidate.src,
                candidate.href,
                candidate.sourceUrl,
                candidate.source_url,
                candidate.publicUrl,
                candidate.public_url,
                candidate.fileUrl,
                candidate.file_url,
                candidate.location,
                candidate.link,
                candidate.original,
                candidate.thumbnail,
                candidate.preview,
            ];

            for (const key of possibleKeys) {
                if (typeof key === 'string' && key.trim()) {
                    const resolved = constructS3FileUrl(key);
                    if (resolved) return resolved;
                }
            }
        }
    }

    if (typeof event === 'object') {
        for (const [key, val] of Object.entries(event)) {
            if (!val) continue;
            const lowerKey = key.toLowerCase();
            if (
                lowerKey.includes('banner') ||
                lowerKey.includes('image') ||
                lowerKey.includes('cover') ||
                lowerKey.includes('media') ||
                lowerKey.includes('asset') ||
                lowerKey.includes('photo') ||
                lowerKey.includes('poster') ||
                lowerKey.includes('thumb') ||
                lowerKey.includes('file')
            ) {
                const resolved = constructS3FileUrl(val);
                if (resolved) return resolved;
            }
        }
    }

    return '';
};

export const getProfileUrl = ({ currentUser, defaultAvatar = true }) => {
    if (defaultAvatar) {
        return `https://api.dicebear.com/7.x/micah/svg?seed=${currentUser?.uuid}&radius=50&backgroundType=solid,gradientLinear&backgroundRotation[]&ears=detached,attached&eyeShadowColor=d2eff3,e0ddff,ffeba4,ffedef,ffffff,transparent&facialHairColor=000000,transparent&glassesProbability=50&mouth=laughing,smile,smirk,surprised&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf`;
    } else {
        return constructS3FileUrl(`${currentUser?.organization.codeName}/profile-images/${currentUser?.uuid}.png`);
    }
};
export const getAvatarColor = (name) => {
    const colors = [
        // '#FFB6C1',
        // '#ADD8E6',
        // '#90EE90',
        // '#FFC0CB',
        // '#FFD700',
        // '#FFA07A',
        // '#00FFFF',
        // '#FF69B4',
        // '#00FF7F',
        // '#87CEEB',

        '#B2BEB5',
        '#708090',
        '#D3D3D3',
        '#36454F',
        '#C0C0C0',
        '#87CEEB',
        '#B0E0E6',
        '#6A5ACD',
        '#4682B4',
        '#6495ED',
        '#D1A2EB',
        '#A2D7EB',
        '#A2EBC7',
        '#EBD8A2',
        '#EBC7A2',
        '#EBB1A2',
        '#EBA2A2',
        '#EBA2CC',
        '#A2CCEB',
        '#A2A2EB',
    ];
    const charCode = name.charCodeAt(0);
    return colors[charCode % colors.length];
};
export const checkUserAccessToResource = ({ resourceName, moduleName, action }) => {
    const user = getItem('current_user');
    if (user?.isAdminDepartment) {
        // check if the resource is allowed for admin
        if (moduleName) {
            const allowedModules = user?.organization?.accessibleModules?.map((m) => m.name) || [];
            if (allowedModules.includes(moduleName)) {
                return true;
            }
            return false;
        }
        return true;
    }
    const index = user?.accesses.findIndex((access) => access?.resource.name === resourceName);
    if (index === -1) {
        return false;
    }
    const allowedActions = user?.accesses[index]?.allowedActions;
    if (allowedActions.includes(action)) {
        return true;
    }
    return false;
};

export const getTagColor = (tagName) => {
    const colors = [
        'magenta',
        'red',
        'volcano',
        'orange',
        'gold',
        'lime',
        'green',
        'cyan',
        'blue',
        'geekblue',
        'purple',
    ];
    if (!tagName) {
        return colors[0];
    }
    let sum = 0;
    for (let i = 0; i < tagName.length; i++) {
        sum += tagName.charCodeAt(i);
    }
    const colorIndex = sum % colors.length;
    return colors[colorIndex];
};

export const getRelativeTimePeriodToText = (start, end) => {
    const startMoment = moment(start);
    const endMoment = moment(end);

    if (startMoment.isSame(moment(), 'day') && endMoment.isSame(moment(), 'day')) {
        return 'Today';
    }

    if (
        startMoment.isSame(moment().subtract(1, 'days'), 'day') &&
        endMoment.isSame(moment().subtract(1, 'days'), 'day')
    ) {
        return 'Yesterday';
    }

    const diffInDays = endMoment.diff(startMoment, 'days');

    if (diffInDays <= 1) {
        return 'Last 2 days';
    }

    if (diffInDays <= 2) {
        return 'Last 3 days';
    }

    if (diffInDays <= 3) {
        return 'Last 4 days';
    }

    if (diffInDays <= 4) {
        return 'Last 5 days';
    }
    if (diffInDays <= 5) {
        return 'Last 6 days';
    }

    if (startMoment.isSame(moment(), 'week') && endMoment.isSame(moment(), 'week') && diffInDays === 6) {
        return 'This week';
    }

    if (
        startMoment.isSame(moment().subtract(1, 'week').startOf('week'), 'week') &&
        endMoment.isSame(moment().subtract(1, 'week').endOf('week'), 'week') &&
        diffInDays === 6
    ) {
        return 'Last week';
    }

    if (
        startMoment.isSame(moment(), 'month') &&
        endMoment.isSame(moment(), 'month') &&
        diffInDays === moment().daysInMonth() - 1
    ) {
        return 'This month';
    }

    if (
        startMoment.isSame(moment().subtract(1, 'month').startOf('month'), 'month') &&
        endMoment.isSame(moment().subtract(1, 'month').endOf('month'), 'month') &&
        diffInDays === moment().subtract(1, 'month').daysInMonth() - 1
    ) {
        return 'Last month';
    }

    if (
        startMoment.isSame(moment(), 'year') &&
        endMoment.isSame(moment(), 'year') &&
        diffInDays === moment().dayOfYear() - 1
    ) {
        return 'This year';
    }

    if (
        startMoment.isSame(moment().subtract(1, 'year').startOf('year'), 'year') &&
        endMoment.isSame(moment().subtract(1, 'year').endOf('year'), 'year') &&
        diffInDays === moment().subtract(1, 'year').dayOfYear() - 1
    ) {
        return 'Last year';
    }

    return `${startMoment.format('DD MMM YY')} - ${endMoment.format('DD MMM YY')}`;
};

export const PERSON_FIELD_KEYS = ['specialization', 'qualification', 'experienceYears', 'availability'];

export const MAX_EXTRA_FIELDS = 10;

export const buildCustomFields = (kind, values) => {
    const customFields = {};
    if (kind === 'person') {
        if (values.specialization) customFields.specialization = values.specialization;
        if (values.qualification) customFields.qualification = values.qualification;
        if (values.experienceYears) customFields.experienceYears = values.experienceYears;
        if (values.availability) customFields.availability = values.availability;
    }
    for (const row of values.extraFields || []) {
        const key = (row?.key || '').trim();
        if (key && !PERSON_FIELD_KEYS.includes(key)) customFields[key] = String(row.value ?? '').trim();
    }
    return Object.keys(customFields).length ? customFields : null;
};

export const toExtraFieldRows = (customFields) =>
    Object.entries(customFields || {})
        .filter(([key]) => !PERSON_FIELD_KEYS.includes(key))
        .map(([key, value]) => ({ key, value: String(value) }));

// Loads the org-themed header/footer starter into an editor opened without a template
export const loadBaseEmailDesign = (apiClient, unlayer) =>
    apiClient
        .get('/api/broadcast-communications/email-templates?defaults=base')
        .then((res) => {
            const design = res.data?.data?.[0]?.emailDesign;
            if (design) unlayer.loadDesign(design);
        })
        .catch((err) => console.error(err));

export * from './mapsUtility';
